export default __webpack_public_path__ + "static/media/NIAS0470.34I-34794_-25717_0.68a94ca7.jpg";